import UserModalComponent from './user-modal-component'
import UserModalService from './user-modal-service'

/***
 * The modal that pops up on the User Admin page, allowing you to update the clients that are assigned to the user.
 */
const userModal = angular
    .module('FacilityData.UserAdmin.UserModal', [])
    .component('userModal', UserModalComponent)
    .service('UserModalService', UserModalService)
    .name;

export default userModal;


// WEBPACK FOOTER //
// ./app/components/user-admin/user-modal/user-modal.js